module.exports = __webpack_public_path__ + "img/infrastructure-utilities.4929c5d2.jpg";